require('angular')

angular.module 'gnp-cache', []
  .factory 'cache', ['$cacheFactory', ($cacheFactory) ->
    $cacheFactory('gnp-data')
  ]



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/cache/cache-module.coffee